export type NavLink = {
  href: string;
  label: string;
};

export const marketingNavLinks: NavLink[] = [
  { href: '/', label: 'Главная' },
  { href: '/templates', label: 'Шаблоны' },
  { href: '/datasets', label: 'Датасеты' },
  { href: '/pricing', label: 'Тарифы' },
  { href: '/api-documentation', label: 'API' },
  { href: '/contact', label: 'Контакты' },
];

export const authenticatedNavLinks: NavLink[] = [
  { href: '/dashboard', label: 'Панель' },
  { href: '/templates', label: 'Шаблоны' },
  { href: '/datasets', label: 'Датасеты' },
  { href: '/billing', label: 'Биллинг' },
  { href: '/settings', label: 'Аккаунт' },
  { href: '/api-documentation', label: 'API' },
  { href: '/help', label: 'Справка' },
];

export const adminNavLinks: NavLink[] = [
  { href: '/admin', label: 'Обзор' },
  { href: '/admin/users', label: 'Пользователи' },
  { href: '/admin/mappings', label: 'Маппинги' },
  { href: '/admin/guest-usage', label: 'Гостевое использование' },
  { href: '/admin/logs', label: 'Логи' },
  { href: '/admin/template-code', label: 'Код шаблонов' },
];

export const footerLinkGroups: Array<{ title: string; links: NavLink[] }> = [
  {
    title: 'Продукт',
    links: [
      { href: '/', label: 'Главная' },
      { href: '/templates', label: 'Шаблоны' },
      { href: '/datasets', label: 'Датасеты' },
      { href: '/pricing', label: 'Тарифы' },
    ],
  },
  {
    title: 'Ресурсы',
    links: [
      { href: '/api-documentation', label: 'API' },
      { href: '/help', label: 'Справка' },
      { href: '/contact', label: 'Контакты' },
    ],
  },
];
